import React, { useEffect, useState, useRef } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useHistory } from "react-router";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Progress from "@configuratorware/configurator-frontendgui/App/Shared/Components/Progress/Progress";
import CategoryGroup from "../CategoryGroup/CategoryGroup";
import { Category } from "../../Types/Types";
import { values } from "lodash";

export const useStyles = makeStyles((theme) => ({
  overviewContainer: {
    padding: "20px 40px",
    height: "calc(100vh - 40px)",
    overflow: "auto",
  },
  overviewTitle: {
    marginBottom: 15,
    fontWeight: "bold",
  },
  info: {
    marginBottom: 20,
  },
  header: {
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      paddingRight: 0,
    },
  },
}));

export interface OverviewProps {
  selectedCategoryId: number;
  categories: Category[];
  setSelectedCategoryId: (id: number | null) => void;
  loadCategories: () => void;
  loadArticle: (identifier: string) => void;
  HeaderComponent: null | any;
  isLoggedIn: boolean;
}

const Overview = (props: OverviewProps) => {
  const classes = useStyles();
  const {
    selectedCategoryId,
    setSelectedCategoryId,
    loadArticle,
    categories,
    HeaderComponent,
    isLoggedIn,
  } = props;
  const history = useHistory();
  const overviewRef = useRef<HTMLDivElement>(null);
  const [showLoader, setShowLoader] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {


    setProducts(values(categories));
  }, [categories]);

  useEffect(() => {
    props.loadCategories();
  }, []);

  return (
    <>
      <Progress loading={showLoader} />
      <div className={classes.overviewContainer} ref={overviewRef}>
        {HeaderComponent && (
          <HeaderComponent
            hideActions={true}
            hideTitle={true}
            className={classes.header}
          />
        )}
        <Typography variant="h5" className={classes.overviewTitle}>
          {t("overview.title")}
        </Typography>
        <Typography className={classes.info}>{t("overview.info")}</Typography>
        {products &&
          products.map((category, i) => (
            <CategoryGroup
              key={i}
              category={category}
              selectedCategoryId={selectedCategoryId}
              setSelectedCategoryId={(id) => {
                setSelectedCategoryId(id);
                overviewRef &&
                  overviewRef.current &&
                  overviewRef.current.scrollTo(0, 0);
              }}
              loadArticle={async (productIdentifier) => {
                setShowLoader(true);
                await loadArticle(productIdentifier);
                setShowLoader(false);
                history.push({
                  pathname: "/identifier:" + productIdentifier,
                  search: window.location.search,
                });
              }}
            />
          ))}
      </div>
    </>
  );
};

export default Overview;
